var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-label-group"},[_c('Select2',{attrs:{"options":_vm.locations,"name":"location_id","id":"location_id","settings":{ placeholder: 'Select Store Location',allowClear:true},"required":_vm.required},model:{value:(_vm.location_id),callback:function ($$v) {_vm.location_id=$$v},expression:"location_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }